export const getStepWithStatusCompany = (transactionStatus, dispatch, ChangeStep) => {
    switch (transactionStatus){
      case "EKYC_DONE":{
        dispatch(ChangeStep(4));
        break;
      }
      case "PAID" : {
        dispatch(ChangeStep(1));
        break;
      }
      case "REJECTED" : {
        dispatch(ChangeStep(1));
        break;
      }
      case "COMPANY_INFORMATION_COMPLETED" : {
        dispatch(ChangeStep(2));
        break;
      }
      case "USER_INFORMATION_COMPLETED" : {
        dispatch(ChangeStep(3));
        break;
      }
      case "CERT_ISSUED" : {
        dispatch(ChangeStep(5));
        break;
      }
      case "SENT_CERT_ISSUED" : {
        dispatch(ChangeStep(5));
        break;
      }
      default:
        dispatch(ChangeStep(0)) //zahra
    } 

}

export const getStepWithStatus = (transactionStatus, dispatch, ChangeStep) => {
  switch (transactionStatus){
    case "EKYC_DONE":{
      dispatch(ChangeStep(3));
      break;
    }
    case "PAID" : {
      dispatch(ChangeStep(1));
      break;
    }
    case "USER_INFORMATION_COMPLETED" : {
      dispatch(ChangeStep(2));
      break;
    }
    case "SENT_CERT_ISSUED" : {
      dispatch(ChangeStep(4));
      break;
    }
    case "CERT_ISSUED" : {
      dispatch(ChangeStep(4));
      break;
    }
    default:
      dispatch(ChangeStep(0)) //zahra
  }

}